import { useCallback } from "react";

export default function useDebounce() {
  const debounce = useCallback((func = () => {}, delay = 0) => {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }, []);

  return debounce;
}
